export const errorMessages = {
  'Back to Sign In': 'サインイン画面に戻る',
  'Confirm': '確認',
  'Confirm Sign Up': 'サインアップの確認',
  'Confirmation Code': '確認コード',
  'Create Account': '新規登録',
  'Create a new account': 'アカウントの新規登録',
  'Create account': '新規登録',
  'Email': 'メールアドレス',
  'Enter your code': '確認コードを入力してください',
  'Enter your password': 'パスワードを入力してください',
  'Enter your Username': 'ユーザー名を入力してください',
  'Forget your password? ': 'パスワードをお忘れの方 ',
  'Have an account? ': 'アカウント登録済みの方 ',
  'Hello': 'こんにちは ',
  'Incorrect username or password.': 'メールアドレスまたはパスワードが正しくありません',
  'Custom auth lambda trigger is not configured for the user pool.': 'メールアドレスまたはパスワードが正しくありません',
  'Invalid email address format.': 'メールアドレスの形式が正しくありません',
  'Lost your code? ': 'コードを紛失した方 ',
  'No account? ': 'アカウント未登録の方 ',
  'Password': 'パスワード',
  'Phone Number': '電話番号',
  'Resend Code': '確認コードの再送',
  'Reset password': 'パスワードのリセット',
  'Reset your password': 'パスワードのリセット',
  'Send Code': 'コードの送信',
  'Sign In': 'サインイン',
  'Sign Out': 'サインアウト',
  'Sign in': 'サインイン',
  'Sign in to your account': 'サインイン',
  'User does not exist': 'ユーザーが存在しません',
  'Username': 'ユーザー名',
  'Username cannot be empty': 'ユーザー名は必須入力です',
  'Username/client id combination not found.': 'ユーザー名が見つかりません',
  'User does not exist.': 'ユーザーが見つかりません',
  'The following fields must be completed: ': '以下の項目は必須です：',
  '1 validation error detected: Value at \'password\' failed to satisfy constraint: Member must have length greater than or equal to 6': 'パスワードは6文字以上にしてください',
  'Password did not conform with policy: Password not long enough': 'パスワードが短すぎます。6文字以上にしてください',
  'Username should be an email.': 'メールアドレスの形式が間違っています',
  'An account with the given email already exists.': 'メールアドレスが既に存在しています',
  'Password did not conform with policy: Password must have numeric characters': 'パスワードは半角英数字で記入してください',
  'Password attempts exceeded': 'ログインが連続で失敗したためアカウントがロックされました。お問い合わせよりパスワードリセットの旨ご連絡下さい',
  'Invalid verification code provided, please try again.': '認証コードが無効です。再度お試しください。',
  'CodeMismatchException': '認証コードが正しくありません。',
  'ExpiredCodeException': '認証コードの有効期限が切れています。再送信してください。',
  'Missing required parameter USERNAME': 'メールアドレスを入力してください。',
  'InvalidParameterException': '無効なパラメータです。入力内容をご確認ください。',
  'UserNotFoundException': 'メールアドレスが見つかりません。',
  'LimitExceededException': 'リクエストの上限を超えました。しばらくしてから再試行してください。',
  'Confirmation code cannot be empty': '認証コードは必須入力です',
  'Attempt limit exceeded, please try after some time.': '試行回数の上限に達しました。しばらく時間をおいてから再度お試しください。',
};

// エラーメッセージを翻訳する関数
export const translateError = (message) => {
  return errorMessages[message] || message;
};